function randomStringUtil (length = 2) {
  return Math.random().toString(36).slice(2, 2 + length)
}

export {
  randomStringUtil
}
